import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#202125',
    },
    secondary: {
      main: '#383838', 
    },
    background: {
      default: '#202125', 
    },
    text: {
      primary: '#ffffff', 
      secondary: '#d4d4d4'
    },
  },
});

export default theme;